import { z } from 'zod';
import { excludeEmptyArray } from './common-schemas/schema-utils';

export const commandSchemas = {
  INIT: z.object({
    type: z.literal('INIT'),
    payload: z.object({
      services: excludeEmptyArray(
        z
          .object({
            service_type: z.string(),
            modal_mode: z.string().optional(),
          })
          .passthrough(),
      ),
    }),
  }),
  START: z.object({
    type: z.literal('START'),
    payload: z.object({
      service_type: z.string(),
      modal_mode: z.string().optional(),
    }),
  }),
};
